(function () {
  function alreadyLoadedSrc(src) {
    return Array.from(document.scripts).some(function (s) {
      return s.src === src;
    });
  }

  function alreadyLoadedHref(href) {
    return !!document.querySelector('link[href="' + href + '"]');
  }

  function loadExternalScript(src) {
    return new Promise(function (resolve) {
      if (alreadyLoadedSrc(src)) {
        resolve();
        return;
      }
      const s = document.createElement('script');
      s.src = src;
      s.onload = function () {
        resolve();
      };
      s.onerror = function () {
        resolve();
      };
      document.body.appendChild(s);
    });
  }

  function runInlineScript(code) {
    const s = document.createElement('script');
    s.textContent = code;
    document.body.appendChild(s);
    s.remove();
  }

  function isExecutableScript(script) {
    const type = (script.getAttribute('type') || '').toLowerCase();
    // Scripts like type="application/json" are data islands (read via getElementById +
    // JSON.parse elsewhere, e.g. multibundles.js), not JS to execute - and must NOT be
    // removed from the fragment afterward, unlike the ones we actually execute.
    return type === '' || type === 'text/javascript' || type === 'application/javascript' || type === 'module';
  }

  async function runScriptsInOrder(fragment) {
    const scripts = Array.from(fragment.querySelectorAll('script'));
    for (const oldScript of scripts) {
      if (!isExecutableScript(oldScript)) continue;
      if (oldScript.src) {
        await loadExternalScript(oldScript.src);
      } else {
        runInlineScript(oldScript.textContent);
      }
    }
  }

  function copyStylesheets(fragment) {
    Array.from(fragment.querySelectorAll('link[rel="stylesheet"]')).forEach(function (link) {
      if (alreadyLoadedHref(link.href)) return;
      document.head.appendChild(link.cloneNode(true));
    });
  }

  function initMainProductSet(container) {
    window.loadMainProductSet = function (productUrl) {
      if (!productUrl) return Promise.resolve();
      container.classList.add('lp-main-product-set--loading');

      return fetch(productUrl)
        .then(function (r) {
          if (r.ok) return r.text();
          return r.text().then(function (body) {
            return Promise.reject(
              new Error(
                'lp-main-product-set: fetch failed (' +
                  r.status +
                  ') for ' +
                  productUrl +
                  '\nResponse: ' +
                  body.slice(0, 500)
              )
            );
          });
        })
        .then(function (html) {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const bundleEl = doc.querySelector('multi-bundle');
          if (!bundleEl) {
            return Promise.reject(new Error('lp-main-product-set: no <multi-bundle> element found on ' + productUrl));
          }
          const sectionWrapper = bundleEl.closest('[id^="shopify-section-"]') || bundleEl.parentElement;

          const template = document.createElement('template');
          template.innerHTML = sectionWrapper.outerHTML;

          copyStylesheets(template.content);

          return runScriptsInOrder(template.content).then(function () {
            Array.from(template.content.querySelectorAll('script')).forEach(function (s) {
              // Keep data-island scripts (e.g. type="application/json") in the DOM - code
              // like multibundles.js reads them later via getElementById + JSON.parse.
              if (isExecutableScript(s)) s.remove();
            });
            Array.from(template.content.querySelectorAll('link[rel="stylesheet"]')).forEach(function (l) {
              l.remove();
            });

            container.innerHTML = '';
            container.appendChild(template.content);
            container.dataset.currentUrl = productUrl;
            container.classList.remove('lp-main-product-set--loading');
          });
        })
        .catch(function (err) {
          container.classList.remove('lp-main-product-set--loading');
          if (window.console) console.error(err);
        });
    };

    document.addEventListener('DOMContentLoaded', function () {
      // Prefer the first bundle card from a "lp-bundle-selector" section elsewhere on the
      // page, if one is present, so the two sections can never drift out of sync (e.g. after
      // reordering blocks there) - fall back to this section's own "product" setting only
      // when no bundle selector exists on the page.
      const firstBundleCard = document.querySelector('.lp-bundle-selector__card');
      const initialUrl = (firstBundleCard && firstBundleCard.getAttribute('data-product-url')) || container.dataset.currentUrl;
      if (initialUrl) window.loadMainProductSet(initialUrl);
    });
  }

  document.querySelectorAll('[data-lp-main-product-set]').forEach(initMainProductSet);
})();
